export const API_URL="https://api.iranianpooshesh.com"
export const APP_API_URL="https://api.sanaap.co"
export const ADJUSTER_PWA_URL="https://expert-pwa.sanaap.co"
export const ESTATE_ADJUSTER_PWA_URL="https://estate-pwa.iranianpooshesh.com"
export const SANAAP_PWA_URL="https://separ-pwa.sanaap.co"